






















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ErrorMessage extends Vue {
	@Prop({ type: Boolean, default: false }) readonly value!: boolean
}
